<template>
  <div class="new-input-box">
    <jd-title label="活动规则" type="bold"></jd-title>
    <el-form-item v-if="needIsForceRemind" label="是否强制提醒:" required>
      <div style="padding-top: 10px">
        <el-radio-group
          v-model="radio"
          @input="isForceRemindChange"
          style="display: flex; flex-direction: column"
        >
          <el-radio style="margin-bottom: 8px" :label="0"
            >不强提醒（用户进入活动后，自行点击“活动规则”查看）</el-radio
          >
          <el-radio :label="1"
            >系统强提醒（用户首次进入活动时，系统自动弹窗提醒活动规则内容）</el-radio
          >
        </el-radio-group>
      </div>
    </el-form-item>
    <el-form-item label="规则内容:" required>
      <div style="width: 570px; padding: 8px 8px 8px 0">
        <el-input
          maxlength="6000"
          type="textarea"
          class="textarea"
          show-word-limit
          style="width: 543px"
          resize="none"
          v-model="ruleDescriptionData"
        ></el-input>
        <div style="margin-top: 16px">
          <jd-button type="blue" @click="generateRule">生成规则</jd-button>
        </div>
        <div class="rule-tip" style="margin-top: 10px">
          <jd-tip color="gley">
            提示：点击按钮自动生成规则，也可以自己编辑信息，手机端规则处显示
          </jd-tip>
        </div>
      </div>
    </el-form-item>
    <!-- 新增字段 -->
    <el-form-item label="是否重点活动:" required>
      <div class="flexc-cen-x mt10">
        <el-radio-group v-model="radioKeyActivity" @input="isKeyActivityChange" :disabled="isDisabled">
          <el-radio :label="0">否</el-radio>
          <el-radio :label="1">是</el-radio>
        </el-radio-group>
        <el-tooltip class="item" effect="dark" placement="top">
          <template slot="content">
            <div>
              大促、品牌高流量等活动建议选「是」，官方会有一定的技术保障资源倾斜
            </div>
          </template>
          <i class="new-icon-box ml8"></i>
        </el-tooltip>
      </div>
    </el-form-item>
    <el-form-item label="活动投放位置:" required>
      <el-checkbox-group v-model="checkLocationList" :disabled="isDisabled" @change="placementPositionChange">
        <el-checkbox label="HOME">京东APP首场曝光位</el-checkbox>
        <el-checkbox label="CHANNEL">大促主会场资源</el-checkbox>
        <el-checkbox label="SEARCH_RECOMMEND">搜索与推荐链路</el-checkbox>
        <el-checkbox label="SHOP">店铺</el-checkbox>
        <el-checkbox label="OUTSIDE">域外曝光</el-checkbox>
        <el-checkbox label="OTHER">其他渠道</el-checkbox>
        <el-tooltip class="item" effect="dark" placement="top">
          <template slot="content">
            <div>上方选择为【是】时请选择活动投放位置便于官方监控流量</div>
          </template>
          <i class="new-icon-box ml8"></i>
        </el-tooltip>
      </el-checkbox-group>
    </el-form-item>
  </div>
</template>
<script>
export default {
  components: {},
  model: {
    prop: "ruleDescription",
    event: "ruleDescriptionUpdate",
  },
  props: {
    ruleDescription: {
      type: String,
      default: "",
    },
    // 是否强提醒
    isForceRemind: {
      type: [Boolean, Number],
      default: 0,
    },
    needIsForceRemind: {
      type: Boolean,
      default: true,
    },
    // 是否重点活动
    isKeyActivity: {
      type: Number,
      default: 0,
    },
    // 活动投放位置
    placementPosition: {
      type: Array,
      default: () => [],
    },
    activityData: {
      type: Object,
      default: () => {},
    },
    valueRow: {
      type: Object,
      default: null,
    },
  },
  watch: {
    isForceRemind: {
      handler: function (v) {
        if (v != null || v != undefined) {
          this.radio = v ? 1 : 0;
        }
      },
      immediate: true,
    },
    isKeyActivity: {
      handler: function (v) {
        if (v != null || v != undefined) {
          this.radioKeyActivity = v ? 1 : 0;
        }
      },
      immediate: true,
    },
    placementPosition: {
      handler: function (v) {
        if (v != null || v != undefined) {
          this.checkLocationList = v;
        }
      },
      immediate: true,
    },
  },
  computed: {
    ruleDescriptionData: {
      get: function () {
        return this.ruleDescription;
      },
      set: function (val) {
        this.$emit("ruleDescriptionUpdate", val);
      },
    },
    isDisabled() {
      let flag = true;
      if(!this.valueRow) {
        flag = false
      }
      if(this.valueRow&&this.valueRow.status==5) {
        flag = false
      }
      if(this.activityData && this.activityData.status == 5) {
        flag = false
      }
      if(this.activityData&&(this.activityData.isCopy||this.activityData.singleCopy)) {
        flag = false
      }
      if((this.activityData.id==8||this.activityData.id==19||this.activityData.id==50)&&this.activityData.status==5) {
        flag = false
      }
      return flag
    }
  },
  data() {
    return {
      radio: 0,
      radioKeyActivity: 0,
      checkLocationList: [],
    };
  },
  created() {},
  mounted() {},
  methods: {
    generateRule() {
      this.$emit("generateRule");
    },
    isForceRemindChange(value) {
      this.$emit("update:isForceRemind", value ? true : false);
    },
    isKeyActivityChange(value) {
      this.$emit("update:isKeyActivity", value ? 1 : 0);
    },
    placementPositionChange(value) {
      this.$emit("update:placementPosition", value);
    },
  },
};
</script>
<style lang="scss" scoped></style>
